<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('report.report_template_library')"
    icon="res-report-template"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :res-id="data.id" :is="params.windowData.currentTab" :id="listId" :data="detailData" :onManager="onManager" :getParams="getParams" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ColumnsMixin from '../mixins/columns'
import Detail from './Detail'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'ReportTemplateSidePage',
  components: {
    Detail,
    Actions,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { key: 'detail', label: this.$t('common_386') },
      ],
    }
  },
  computed: {
    getParams () {
      return {}
    },
    listId () {
      return ''
    },
  },
}
</script>
